import {
  Box, Container, makeStyles, Typography,
} from '@material-ui/core';

import errResponsive from '../../assets/img/errResponsive.png';
import logo from '../../assets/logo/Logo.png';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 3),
    height: window.innerHeight,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxHeight: '50%',
  },
  logo: {
    maxWidth: '30%',
    padding: theme.spacing(5, 0, 10, 0),
  },
  img: {
    maxWidth: '100%',
  },
  text: {
    fontFamily: 'Raleway',
    color: theme.palette.text.default,
    textAlign: 'center',
    margin: theme.spacing(4, 0),
  },
}));
function ErrDimensions() {
  const classes = useStyles();
  return (
    <Container maxWidth="xs" className={classes.container}>
      <img src={logo} alt="logo" className={classes.logo} />
      <Box className={classes.content}>
        <img src={errResponsive} alt="err" className={classes.img} />
        <Typography variant="h5" className={classes.text}>
          ¡Lo sentimos por el momento la página web solo se puede ver desde una computadora!
        </Typography>
      </Box>
    </Container>
  );
}

export default ErrDimensions;
